// extracted by css-extract-rspack-plugin
export default {"variantLabelInput":"src-wab-client-components-VariantControls-module__variantLabelInput-WxosHX","variantLabelInput__recording":"src-wab-client-components-VariantControls-module__variantLabelInput__recording-YILAdd","variantLabelInputRecording":"src-wab-client-components-VariantControls-module__variantLabelInput__recording-YILAdd","styleVariantEditor":"src-wab-client-components-VariantControls-module__styleVariantEditor-ipfSqW"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"variantLabelInput\":\"src-wab-client-components-VariantControls-module__variantLabelInput-WxosHX\",\"variantLabelInput__recording\":\"src-wab-client-components-VariantControls-module__variantLabelInput__recording-YILAdd\",\"variantLabelInputRecording\":\"src-wab-client-components-VariantControls-module__variantLabelInput__recording-YILAdd\",\"styleVariantEditor\":\"src-wab-client-components-VariantControls-module__styleVariantEditor-ipfSqW\"}";
        // 1793541994662
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  